/* Load scroll choreography when its section approaches the viewport. */
(() => {
  const script = document.currentScript;
  const scene = document.querySelector('[data-solid-scene="product"]');
  if (!script || !scene) return;
  let loading;
  const load = (src) => new Promise((resolve, reject) => {
    const element = document.createElement('script');
    element.src = src;
    element.onload = resolve;
    element.onerror = reject;
    document.head.append(element);
  });
  const start = () => loading ||= (async () => {
    if (!window.gsap) await load(script.dataset.gsap);
    if (!window.ScrollTrigger) await load(script.dataset.scroll);
    await load(script.dataset.scenes);
  })().catch(() => { /* Native details and horizontal scrolling still work. */ });
  // A first anchor jump can race with ScrollTrigger's initial layout refresh.
  // Complete that setup before beginning the same smooth navigation.
  document.addEventListener('click', async event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('a[href]');
    if (!link || link.target || link.hasAttribute('download')) return;
    const destination = new URL(link.href, location.href);
    if (destination.origin !== location.origin || destination.pathname !== location.pathname || destination.search !== location.search || destination.hash !== `#${scene.id}`) return;
    event.preventDefault();
    await start();
    await document.fonts.ready;
    window.ScrollTrigger?.refresh();
    if (location.hash !== destination.hash) history.pushState(null, '', destination.hash);
    scene.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  });
  if (!('IntersectionObserver' in window) || window.Shopify?.designMode) {
    start();
    return;
  }
  const observer = new IntersectionObserver(entries => {
    if (!entries.some(entry => entry.isIntersecting)) return;
    observer.disconnect();
    start();
  }, { rootMargin: '600px' });
  observer.observe(scene);
})();
